export const inlineStyleMap = {
	'CODE': {
		'display': 'inline-block',
        'marginLeft': '10px',
        'marginRight': '10px',
        'backgroundColor': '#F3F5F9',
        'borderRadius': '0',
        'padding': '0 12px',
        'color': '#0ABF5B',
        'fontFamily': 'Consolas, "Liberation Mono", Menlo, Courier, "Microsoft Yahei", monospace',
        'lineHeight': '20px'
	},
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/inlineStylePlugin/inlineStyleMap.js